<template>
	<span>
		<Row class="mb-10">
			<div class="inner-title">{{$t('郵遞區號')}}</div>
			<Col :xs="5" :sm="5" :md="2" :lg="2">
				<Input :maxlength="3" class="pr-5" v-model="zipCode" :disabled="disabled" @input="update"></Input>
			</Col>
			<Col :xs="10" :sm="10" :md="4" :lg="4">
				<Select v-model="county" :disabled="disabled" class="pr-5">
					<Option
						v-for="county in counties"
						:value="county.name"
						:key="county.name"
						:label="county.name"
					></Option>
				</Select>
			</Col>
			<Col :xs="8" :sm="6" :md="4" :lg="4">
				<Select v-model="district" :disabled="disabled" class="pr-5">
					<Option
						v-for="district in districts"
						:value="district.name"
						:key="district.name"
						:label="district.name"
					></Option>
				</Select>
			</Col>
			<Col :xs="7" :sm="6" :md="4" :lg="4">
				<Input
					v-model="village"
					:placeholder="$t('龍安里')"
					:disabled="disabled"
					@input="update"
					class="pr-5"
				></Input>
			</Col>
			<div class="inner-title">({{$t('村里')}})</div>
			<Col :xs="7" :sm="6" :md="4" :lg="4">
				<Input v-model="neighborhood" placeholder="2" :disabled="disabled" @input="update" class="pr-5"></Input>
			</Col>
			<div class="inner-title">({{$t('鄰')}})</div>
		</Row>
		<Input v-model="address" :disabled="disabled" @input="update"></Input>
	</span>
</template>
<script>
import DISTRICT_ZIP from '@/district-zip.json'

export default {
	data() {
		return {
			zipCode: DISTRICT_ZIP[0].districts[0].zip,
			county: DISTRICT_ZIP[0].name,
			district: DISTRICT_ZIP[0].districts[0].name,
			village: '',
			neighborhood: '',
			address: '',
			counties: DISTRICT_ZIP, //縣市下拉選單
		}
	},
	props: {
		value: {
			type: String,
			default: null,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		districts() {
			return this.counties.find(county => county.name == this.county).districts
		},
	},
	watch: {
		value: {
			immediate: true,
			handler(newVal, oldVal) {
				if (!this.value) {
					return
				}
				let addressTokens = this.value.split(',')

				//當地址格式不正確，則不帶入使用者目前地址
				if (addressTokens.length < 6) {
					return
				}
				this.zipCode = addressTokens[0]
				this.county = addressTokens[1]
				this.district = addressTokens[2]
				this.village = addressTokens[3]
				this.neighborhood = addressTokens[4].replace(this.$t('鄰'), '')
				this.address = addressTokens[5]
			},
		},
		districts() {
			//避免更新的預設值取代掉已填寫的地址(鄉區市鎮)
			if (
				this.districts.find(district => district.name == this.district && district.zip == this.zipCode) ===
				undefined
			) {
				this.district = this.districts[0].name
			}
		},
		district() {
			this.zipCode = this.districts.find(district => district.name == this.district).zip
			this.update()
		},
	},
	methods: {
		update() {
			this.$nextTick(() => {
				this.$emit(
					'input',
					[
						this.zipCode,
						this.county,
						this.district,
						this.village,
						this.neighborhood ? this.neighborhood + this.$t('鄰') : this.neighborhood,
						this.address,
					].join(),
				)
			})
		},
		validate() {
			return [this.zipCode, this.county, this.district, this.village, this.neighborhood, this.address].every(
				value => value,
			)
		},
		validateAddressOnly() {
			return this.address
		},
	},
}
</script>
<style scoped>
.inner-title {
	float: left;
	padding-right: 10px;
}
.mb-10 {
	margin-bottom: 10px;
}
.pr-5 {
	padding-right: 5px;
}
</style>
